import React from 'react';
import {observer} from "mobx-react";
import {AreaHoursChart} from "./area-hours-chart";
import {useCallback, useEffect} from "react";
import axios from "axios";
import store from "../../store";

function KpiPerHoursGraphs() {
  useEffect(() => {
    fetchLastHourSumData();
  }, []);

  const fetchLastHourSumData = useCallback(async () => {
    const result = await axios.get(`${process.env.REACT_APP_BASE_URL_API}/monitoring/last-hours`)

    store.setLastHoursEvents(result.data);
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-6">
      {
        store.last_hours_events.length > 0 && Object.keys(store.last_hours_events[0]).map((kpi, i) => (
          <AreaHoursChart entities={store.last_hours_events} key={i} data_key={kpi} index={0} label="only_hour"/>))
      }
    </div>
  );
}

export default observer(KpiPerHoursGraphs);
